import type { MeasurementDefinition, Unit } from "./gen/observations-vue";

/**
 * Extract the timestamp from a UUIDv7
 */
export function uuidV7ToTimestamp(uuid: string): Date {
  const hex = uuid.slice(0, 8) + uuid.slice(9, 13);
  const millisecondsSinceEpoch = Number.parseInt(hex, 16);
  return new Date(millisecondsSinceEpoch);
}

export function reltime(time: Date | string | undefined): string | undefined {
  const dt: Date | undefined = typeof time === "string" ? new Date(time) : time;
  let fmt = undefined;
  if (dt) {
    const elapsed = Date.now() - dt.getTime();
    const local = new Date(dt.getTime() - dt.getTimezoneOffset() * 60_000);
    fmt = local.toISOString();
    fmt =
      elapsed > 24 * 60 * 60 * 1000
        ? fmt.slice(0, 10) + " " + fmt.slice(11, 16)
        : fmt.slice(11, 16);
  }
  return fmt;
}

const timeFmt = new Intl.DateTimeFormat("nl-NL", {
  hour: "numeric",
  minute: "numeric",
});

export function formatHourMinute(date: Date): string {
  return timeFmt.format(date);
}

export function splitNumber(
  value: number,
  precision: number,
): [string, string] {
  const intValue = Math.floor(value).toString();
  const suffix = (value % 1).toFixed(precision).replace(/^[0-9]+/, "");
  return [intValue, suffix];
}

export interface SplitMeasurementValue {
  integerPart: string;
  fractionalPart: string;
  unit: string;
}

function unitToSymbol(unit: Unit): string {
  switch (unit) {
    case "Meter": {
      return "m";
    }
    case "Kilogram": {
      return "kg";
    }
  }
  return "";
}

export function splitMeasurementValue(
  significand: number,
  definition: MeasurementDefinition,
) {
  const value = significand * Math.pow(10, -definition.exponent);
  const [integerPart, fractionalPart] = splitNumber(value, definition.exponent);
  return {
    integerPart,
    fractionalPart,
    unit: unitToSymbol(definition.unit),
  };
}
